export default __webpack_public_path__ + "static/media/wood-floor-adhesive.95834715.jpeg";